// Typed static client for the image/* endpoints.
// All-static, returns typed data (never a raw AxiosResponse), rethrows errors.
// Follows the PositiveIdService precedent. Call sites keep their own handling.
//
// URLs are relative (resolved against axios.defaults.baseURL /api) and
// preserved verbatim from the page's call sites.

import axios from 'axios'

/** Metadata for a stored image (page count + provenance). */
export interface ImageInformation {
    pageCount?: number
    createdBy?: string
}

export class ImageService {
    /** Image metadata — page count and created-by (used to detect faxed scripts). */
    static async getImageInformation(imageId: number): Promise<ImageInformation> {
        const response = await axios.get<ImageInformation>(`image/ImageInformation/${imageId}`)
        return response.data
    }

    /** Raw image bytes as a Blob, for inline/object-URL rendering. */
    static async getImageBlob(imageId: number): Promise<Blob> {
        const response = await axios.get(`image/${imageId}`, { responseType: 'blob' })
        return response.data as Blob
    }
}

export default ImageService
